import { useTranslation } from 'react-i18next';
import { Info, Building2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { SimpleSelect } from '@/shared/ui/filters';
import { FormField } from '@/shared/ui';
import type { SelectOption } from '@/shared/ui';

interface OrganizationSelectProps {
  label: string;
  organizationId?: string;
  options: SelectOption[];
  isLoading: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  onChange: (id: string | undefined) => void;
  handleOrgOpen: () => void;
}

export const OrganizationSelect = ({
  label,
  organizationId,
  options,
  isLoading,
  disabled = false,
  required = false,
  error,
  onChange,
  handleOrgOpen
}: OrganizationSelectProps) => {
  const { t } = useTranslation();

  return (
    <FormField
      label={`${label} ${t('common.organization', 'Organization')}`}
      name="organization"
      required={required}
      error={error}>
      <div className="flex gap-2">
        <SimpleSelect
          options={options}
          value={organizationId}
          onChange={onChange}
          isLoading={isLoading}
          placeholder={t('common.selectOrganization', 'Search organization')}
          className="flex-1"
          disabled={disabled}
        />

        {organizationId && (
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={handleOrgOpen}
            className="w-11 border-slate-300 bg-white hover:bg-slate-50 transition-colors"
            title={disabled ? t('organizations.viewDetails') : t('organizations.editOrganization')}>
            {disabled ? <Info className="w-4 h-4 text-slate-600" /> : <Building2 className="w-4 h-4 text-slate-600" />}
          </Button>
        )}
      </div>
    </FormField>
  );
};
